var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-len */
import React, { Component } from 'react';











const defaultProps = {
  allowClose: true,
  children: ''
};

export class Notice extends Component {


  static learnIconSvg() {
    return (/*#__PURE__*/
      _jsx("svg", {
        width: "29",
        height: "29",
        viewBox: "0 0 29 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg" }, void 0, /*#__PURE__*/

      _jsx("circle", { cx: "14.5", cy: "14.5", r: "14.5", fill: "#2B56C1" }), /*#__PURE__*/
      _jsx("path", {
        d: "M14.8971 16.9227C14.8314 16.9446 14.7657 16.9665 14.7 16.9665C14.6343 16.9665 14.5686 16.9446 14.503 16.9227L7.86842 14.3389V18.1927C7.86842 20.8202 12.6418 21.1048 14.7 21.1048C16.7583 21.1048 21.5316 20.8202 21.5316 18.1927V14.3389L14.8971 16.9227Z",
        fill: "#FAFBFF" }
      ), /*#__PURE__*/
      _jsx("path", {
        d: "M24.1372 11.6238L14.8533 8.03284C14.7438 7.98905 14.6343 7.98905 14.5467 8.03284L5.28465 11.6238C5.10948 11.6895 5 11.8428 5 12.0398C5 12.2369 5.10948 12.3902 5.28465 12.4559L14.5467 16.0249C14.5905 16.0468 14.6562 16.0468 14.7 16.0468C14.7438 16.0468 14.8095 16.0468 14.8533 16.0249L24.1154 12.4559C24.2905 12.3902 24.4 12.2369 24.4 12.0398C24.4 11.8428 24.2905 11.6895 24.1372 11.6238Z",
        fill: "#FAFBFF" }
      )
      ));

  }

  constructor(props) {
    super(props);
    this.state = {
      isHidden: false
    };

    this.close = this.close.bind(this);
  }

  close() {
    this.setState({ isHidden: true });
  }

  render() {
    const { children, title, allowClose } = this.props;
    const { isHidden } = this.state;

    return (/*#__PURE__*/
      _jsx("div", { className: `notice ${isHidden ? 'is-hidden' : ''}` }, void 0, /*#__PURE__*/
      _jsx("div", { className: "header" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "icon" }, void 0, Notice.learnIconSvg()), /*#__PURE__*/
      _jsx("span", { className: "title" }, void 0, title),
      allowClose && /*#__PURE__*/
      _jsx("button", { className: "close-notice", onClick: this.close, type: "button", "no-translate": true }, void 0, "X"

      )

      ), /*#__PURE__*/
      _jsx("div", { className: "main" }, void 0, children)
      ));

  }
}_defineProperty(Notice, "defaultProps", defaultProps);